var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeeLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1824 4.24249C9.84505 4.09497 7.85904 5.80226 7.68529 7.97793C7.51231 10.1439 9.19352 12.0702 11.5233 12.2172C13.8606 12.3647 15.8466 10.6575 16.0204 8.48178C16.0208 8.47723 16.0211 8.47269 16.0215 8.46814C15.8469 8.49307 15.6675 8.50061 15.4854 8.48912C14.107 8.40212 13.0137 7.23731 13.1266 5.8243C13.1642 5.35309 13.3311 4.92664 13.5875 4.57142C13.1569 4.38907 12.6844 4.27417 12.1824 4.24249ZM14.3929 3.84655C13.7546 3.50699 13.0295 3.29411 12.2509 3.24497C9.39846 3.06494 6.90783 5.15081 6.68797 7.90389C6.46811 10.657 8.60227 13.0347 11.4547 13.2147C14.3072 13.3948 16.7979 11.3089 17.0177 8.55583C17.03 8.40228 17.0349 8.24989 17.0328 8.09899C17.0273 7.69881 16.9722 7.30907 16.8729 6.93566C16.6457 7.20364 16.3265 7.39437 15.9667 7.46486C15.8338 7.49089 15.6953 7.50053 15.5539 7.49161C14.6982 7.4376 14.058 6.72427 14.1239 5.89835C14.1488 5.58616 14.2711 5.30257 14.4598 5.07348C14.6869 4.79764 15.0104 4.60081 15.3761 4.5282C15.0794 4.26572 14.7497 4.03634 14.3929 3.84655Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 8.22705C23 7.77854 22.7455 7.484 22.2365 6.89491C20.3744 4.73973 16.2673 0.727051 11.5 0.727051C6.73266 0.727051 2.62556 4.73972 0.763465 6.89491C0.254488 7.484 0 7.77854 0 8.22705C0 8.67556 0.254488 8.9701 0.763464 9.55919C2.62555 11.7144 6.73266 15.7271 11.5 15.7271C16.2673 15.7271 20.3744 11.7144 22.2365 9.55919C22.7455 8.9701 23 8.67556 23 8.22705ZM11.1456 14.4771C15.735 14.4771 20.98 10.2981 20.98 8.22705C20.98 6.15598 15.735 1.97705 11.5 1.97705C7.265 1.97705 2.62249 6.15598 2.62249 8.22705C2.62249 10.2981 7.21186 14.4771 11.1456 14.4771Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeLight);
export default __webpack_public_path__ + "static/media/see_light.4ab86bc35f0d79ca423aefaac86e592f.svg";
export { ForwardRef as ReactComponent };